import { Link } from "@StarberryUtils";
import React, { useEffect, useState } from "react"
//import ScrollAnimation from "react-animate-on-scroll";
import { Button, Container, Row, Col } from "react-bootstrap"
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import HTMLReactParser from 'html-react-parser';
import axios from 'axios';
import ModalTiny from "react-bootstrap/Modal"
import SEO from "../../seo"
import PlayVideo from "../../Play/custom-video";
import founderimg01 from "../../../images/staticpage/founder/mob-img.png";
import founderimg02 from "../../../images/staticpage/founder/tab-img.png";
import founderimg03 from "../../../images/staticpage/founder/desktop-img.png";
import Logo from '../../../images/dacha-logo-blue.png';
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
import Loadable from "@loadable/component"
import { CloseIcon } from "../../Icons/Icons";


import PeopleProperties from "../../Home/Properties/PeopleProperties";
import Form from "../../forms/reach-us-form";
import _ from "lodash"
import "./Founder.scss"
// markup

import Breadcrumb from "../../../components/Home/Breadcrumb/Breadcrumb";


const GET_PEOPLE = gql`
  query GetPeople($url: String!){ 
    peoples(sort:"createdAt:asc", where:{URL:$url})  {
        Meta_Title
        Meta_Description
        Name
        id
        URL
        Phone
        Email
        people_locations{
            Name
        }
        people_languages{
            Name
        }
        Full_Image {
          url
          alternativeText
        }
        Designation 
        Email
        Phone
                      ggfx_results {
                    id
                    src_cftle
                    src_url
                    transforms
                    updatedAt
                    createdAt
                    _id
            }
        About
        imagetransforms
        Neg_Id
        reapit_code
        Broker_Reg_Number
        certified_people{
            Neg_Id
        }
        Video_URL
      }
  }
`;

const StaticComponent = (props) => {

    const [modalAskformOpen, setAskformOpen] = React.useState(false);
    const [propItems, setPropItems] = useState(false)
    const [people, setPeople] = useState(null)
    const openAskformModal = () => {
        setAskformOpen(true);
    }
    const closeAskformModal = () => {
        setAskformOpen(false);
    }
    const getitems = async url => {
        try {
            const { data } = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
                }
            })
            setPropItems(data)
        } catch (error) {
            console.error(error)
        }
    }
    const { loading, error, data } = useQuery(GET_PEOPLE, { variables: { url: props.url } });
    console.log(people,"adattshskj")
    if (!loading && people == null) {

        setPeople(data.peoples[0]);
    }

    useEffect(() => {
        if (people) {
            var negId = people?.Email;
            if (_.isEmpty(negId)) {
                negId = people?.certified_people?.Neg_Id
            }
            if (!_.isEmpty(negId)) {
                let url = process.env.GATSBY_STRAPI_SRC + "/properties?_limit=8&_sort=published_at:DESC&publish=true"; // TODO: base URL supposed to be from .env

                url = url + "&negotiator_email=" + negId;

                getitems(url)
            }
        }
    }, [people])



    if (loading) return <div className="gql-loading-screen"><img loading="lazy" src={Logo} alt="Loading - Dacha" /><p>Loading ...</p></div>;



    const image_url = people?.Full_Image.url
        const ImageSrc = {
     url:   people?.Full_Image.url
    }
    let processedImages = JSON.stringify({});
    if (people?.imagetransforms?.Full_Image_Transforms) {
        processedImages = people.imagetransforms.Full_Image_Transforms;
    }
	
    var whatsapp_no = "971586234140";

    return (
        <React.Fragment>
            <section className="founder">
            <div className="founder-img-mobile img-zoom">
                                            {/* <ImageTransform
                                                imagesources={image_url}
                                                renderer="srcSet"
                                                imagename="peoples.Full_Image.details"
                                                attr={{ alt: people?.Name + ' - Dacha', class: '' }}
                                                imagetransformresult={processedImages}
                                                id={people?.id}
                                            /> */}
                                            <ImageModule 
                                                ImageSrc={ImageSrc} 
                                                attr={{ alt: people?.Name + ' - Dacha' || "" }} 
                                                ggfx_results={people?.ggfx_results} 
                                                imagename="peoples.Full_Image.details" 
                                                strapi_id={people?.id} 
                                            />
                                            {people?.Video_URL && (
                                                <div className="banner-btn people-banner">
                                                    <PlayVideo url={people?.Video_URL} />
                                                </div>
                                            )}
                                        </div>
            <div className="container">
                    <Row>
                        <div className="container">
                        {people && (
                            <div animateIn='fadeInUp' animateOnce>
                                <SEO
                                    image_url={image_url}
                                    title={`${people.Meta_Title} | Real Estate Experts`}
                                    description={`Find out, what motivates ${people.Meta_Title} to be a real estate expert, making Dacha the local property experts.`}
                                    location={props.location}
                                />
                                <div className="founder-content">
                                    <div className="about-founder">
                                        <h1>{people.Name}</h1>
                                        <span className="sm-info">{people.Designation}</span>
                                        {people.Broker_Reg_Number && <h6 className="text-sm-bold brn-id">BRN ID: {people.Broker_Reg_Number}</h6>}
                                        <div className="people-contact">
                                        <a href={`tel:${people.Phone}`} className="people-button people-phone">
                                            <i className="phone-trans-icon"></i>
                                                Call
                                            </a>
                                            <a href="javascript:void(0)" onClick={openAskformModal} className="people-button people-mail">
                                                <i className="mail-trans-icon"></i>
                                                Email
                                            </a>                                
                                            <a href={`https://wa.me/${whatsapp_no}`} className="people-button people-whatsapp">
                                            <i className="whatsapp-trans-icon"></i>
                                                WhatsApp
                                            </a>
                                        </div>

                                        {!_.isEmpty(people.people_languages) && (
                                            <div className="people-language">
                                                <span className="people-mail">
                                                    <i className="language-icon-new"></i>
                                                    {_.join(_.map(people.people_languages, 'Name'), ' | ')}
                                                </span>
                                            </div>
                                        )}
                                        {people.Name === "Alessia Sheglova" && (
                                            <div className="people-language">
                                                <span className="people-mail">
                                                <a 
                                                    href="https://www.instagram.com/alessia_sheglova/" 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >
                                                    <i className="instagram-icon-new"></i>
                                                </a>    
                                                <a 
                                                    href="https://www.linkedin.com/in/alessia-sheglova-35061759/" 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >
                                                    <i className="linkedin-icon-new"></i>
                                                </a>
                                                </span>
                                            </div>
                                            
                                        )}
                                        {!_.isEmpty(people.people_locations) && (
                                            <div className="people-location">
                                                <span className="people-mail">
                                                    <i className="location-icon"></i>
                                                    {_.join(_.map(people.people_locations, 'Name'), ' | ')}
                                                </span>
                                            </div>
                                        )}
                                        <div className="founder-info">
                                            {people.About && HTMLReactParser(people.About.replace(/<br\s*\/?>/gi, ''))}
                                        </div>
                                    </div>

                                    {/* <Col xl={6} className="order-xl-2"> */}
                                        <div className="founder-img img-zoom">
                                            {/* <ImageTransform
                                                imagesources={image_url}
                                                renderer="srcSet"
                                                imagename="peoples.Full_Image.details"
                                                attr={{ alt: people.Name + ' - Dacha', class: '' }}
                                                imagetransformresult={processedImages}
                                                id={people.id}
                                            /> */}
                                            <ImageModule 
                                                ImageSrc={ImageSrc} 
                                                attr={{ alt: people?.Name + ' - Dacha' || "" }} 
                                                ggfx_results={people.ggfx_results} 
                                                imagename="peoples.Full_Image.details" 
                                                strapi_id={people?.id} 
                                            />
                                            {people.Video_URL && (
                                                <div className="banner-btn people-banner">
                                                    <PlayVideo url={people.Video_URL} />
                                                </div>
                                            )}
                                        </div>
                                    {/* </Col> */}
                                </div>
                            </div>
                        )}
                        </div>
                    </Row>
                    </div>
            </section>

            {people && people?.Email &&
                <PeopleProperties link={people.reapit_code} name={people.Name.split(" ")[0]} seqno={people.Email} propItems={[]} phone={people.Phone} email={people.email} fullName = {people.Name} />
            }


            {people &&
                <ModalTiny show={modalAskformOpen} onHide={closeAskformModal} className="modal-form-wrapper">
                    <ModalTiny.Header>
                    <div class="modal-close-btn" onClick={closeAskformModal}><CloseIcon /></div>
                        <ModalTiny.Title><h4>Contact {people.Name}</h4></ModalTiny.Title>
                    </ModalTiny.Header>
                    <ModalTiny.Body>
                        <Form peopleName={people.Name} />
                    </ModalTiny.Body>
                </ModalTiny>
            }


        </React.Fragment>
    )
}

export default StaticComponent